import { slugIsKnownFilter } from './urlIsKnownFilter';
import { titleCase } from '@utils/plp/utils/transforms';

export const getFilterLabel = (filter: string) => {
  return titleCase(filter.replace(/-/g, ' '));
};

export const getCategorySlugsFromUrl = (url: string, locale = 'en') => {
  const { fullCategorySlug } =
    /(products|produits)\/(?<fullCategorySlug>.*?)\/?$/.exec(url)?.groups ?? {};

  const categorySlug = fullCategorySlug?.split('/').filter((slug) => {
    return !slugIsKnownFilter(slug, locale);
  });

  const categoryFilters = fullCategorySlug?.split('/').filter((slug) => {
    return slugIsKnownFilter(slug, locale);
  });

  const filterPath = categoryFilters?.map(getFilterLabel).join(' > ') || '';

  return { categorySlug, categoryFilters, filterPath };
};
